module.exports = __webpack_public_path__ + "static/media/docpos.2727f657.svg";